import { render, staticRenderFns } from "./trail_info.vue?vue&type=template&id=5f2f9d50&"
import script from "./trail_info.vue?vue&type=script&lang=js&"
export * from "./trail_info.vue?vue&type=script&lang=js&"
import style0 from "./trail_info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports